import { useDecision } from '@optimizely/react-sdk';

import { OperationsName } from '../types/user';

import CanUser from './CanUser';

type CanUserWithFeatureFlagProps = {
  featureKey: string;
  enabledPermissions: OperationsName[];
  disabledPermissions: OperationsName[];
  children: JSX.Element;
};

function CanUserWithFeatureFlag({
  featureKey,
  enabledPermissions,
  disabledPermissions,
  children,
}: CanUserWithFeatureFlagProps) {
  const [decision] = useDecision(featureKey);
  const operations = decision.enabled ? enabledPermissions : disabledPermissions;

  return <CanUser operations={operations}>{children}</CanUser>;
}

export default CanUserWithFeatureFlag;
